module.exports = __webpack_public_path__ + "img/bg1.dc921125.png";